module.exports = __webpack_public_path__ + "web/img/sign-80.22cb72fe.png";